module.exports = __webpack_public_path__ + "img/nosotros.5a1e7801.png";